import React, { useState } from 'react';
import { Modal, Checkbox } from 'antd';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CloseOutlined } from '@ant-design/icons';
import { ButtonWrapper } from 'components/ButtonWrapper';

const StyledModal = styled(Modal)`
	.ant-modal-content {
		box-sizing: border-box;
		width: 870px !important;
		height: 503px;
		background: #fff;
		border: 1px solid #000;
		border-radius: 4px;
		padding: 0;
		position: relative;
		display: flex;
		flex-direction: column;
	}
	.ant-modal-header {
		display: none;
	}
	.ant-modal-footer {
		display: none;
	}
`;

const Title = styled.div`
	position: absolute;
	width: 100%;
	top: 29px;
	text-align: center;
	font-family: 'Inter', sans-serif;
	font-weight: 600;
	font-size: 24px;
	color: #000;
	line-height: 29px;
`;

const Divider = styled.div`
	position: absolute;
	width: 774px;
	left: 48px;
	top: 82px;
	border-top: 1px solid #737373;
`;

const WarningList = styled.div`
	position: absolute;
	left: 72px;
	top: 106px;
	width: 747px;
`;

const WarningLine = styled.div`
	font-family: 'Inter', sans-serif;
	font-weight: 400;
	font-size: 16px;
	line-height: 160%;
	color: #737373;
	margin-bottom: 15px;
`;

const Irreversible = styled(WarningLine)`
	margin-top: 10px;
`;

const ConfirmRow = styled.div`
	position: absolute;
	top: 320px;
	left: 72px;
	width: 747px;
	display: flex;
	align-items: center;
	gap: 12px;
`;

const ConfirmText = styled.span`
	font-family: 'Inter', sans-serif;
	font-weight: 500;
	font-size: 20px;
	color: #000;
	word-break: break-word;
`;

const ModalFooter = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	gap: 123px;
	position: absolute;
	width: 721px;
	height: 60px;
	left: 88px;
	top: 384px;
`;

export default function DeactivateBusinessUnitModal({ open, onCancel, onDeactivate, loading }) {
	const [checked, setChecked] = useState(false);

	return (
		<StyledModal
			open={open}
			onCancel={onCancel}
			footer={null}
			centered
			width={870}
			bodyStyle={{ padding: 0 }}
			closeIcon={
				<CloseOutlined
					onClick={() => {
						onCancel();
						setChecked(false);
					}}
					type="button"
					style={{ fontSize: 20, color: '#000' }}
				/>
			}
		>
			<div style={{ position: 'relative', width: '100%', height: '100%' }}>
				<Title>Deactivate Business Unit</Title>
				<Divider />
				<WarningList>
					<WarningLine>
						All Projects under this Business Unit will be marked as inactive.
					</WarningLine>
					<WarningLine>
						All Users mapped to this BU will lose access to the Business Unit.
					</WarningLine>
					<WarningLine>
						This Business Unit will no longer appear in reports, dashboards, or filters.
					</WarningLine>
					<WarningLine>
						Any active Projects or Users will be automatically deactivated or removed.
					</WarningLine>
					<Irreversible>This action is irreversible.</Irreversible>
				</WarningList>
				<ConfirmRow>
					<Checkbox
						checked={checked}
						onChange={(e) => setChecked(e.target.checked)}
						style={{ transform: 'scale(1.4)' }} // makes checkbox better match font size
					/>
					<ConfirmText>Confirm for Deactivation</ConfirmText>
				</ConfirmRow>
				<ModalFooter>
					<ButtonWrapper
						onClick={() => {
							onCancel();
							setChecked(false);
						}}
						style={{
							border: '1px solid #FF3B30',
							color: '#FF3B30',
							background: '#fff',
							borderRadius: 4,
							height: 60,
							minWidth: 200,
							fontSize: 16,
							fontWeight: 500,
							padding: '8px 60px',
						}}
						disabled={loading}
					>
						Cancel
					</ButtonWrapper>
					<ButtonWrapper
						type="primary"
						style={{
							background: checked ? '#143E60' : '#C6C6C8',
							color: '#fff',
							border: 'none',
							borderRadius: 4,
							height: 60,
							minWidth: 200,
							fontSize: 16,
							fontWeight: 500,
							padding: '8px 60px',
							cursor: checked ? 'pointer' : 'not-allowed',
						}}
						disabled={!checked || loading}
						onClick={onDeactivate}
						loading={loading}
					>
						Deactivate
					</ButtonWrapper>
				</ModalFooter>
			</div>
		</StyledModal>
	);
}

DeactivateBusinessUnitModal.propTypes = {
	open: PropTypes.bool.isRequired,
	onCancel: PropTypes.func.isRequired,
	onDeactivate: PropTypes.func.isRequired,
	loading: PropTypes.bool,
};
